export default "__VITE_ASSET__DLWKCQYP__"